import React from 'react';
import {useFormContext} from 'react-hook-form';
import {useTranslation} from 'react-i18next';
import {Link, generatePath} from 'react-router';

import {Button} from '@edna/components';

import {EChannelType} from 'src/constants';
import PATHS, {VIEW_POSTFIX} from 'src/paths';

import {EApproveStatus, EType, TFormData, TMessageMatcher, TWhatsAppContent} from './definitions';
import {getRoute} from './utils';

export const checkTemplateHasStatistics = (values: TFormData) => {
  if (values.type !== EType.OPERATOR) {
    return false;
  }

  if (
    values.channelType === EChannelType.WHATSAPP &&
    (values.content as TWhatsAppContent).requestCallPermission
  ) {
    return false;
  }

  return (
    !!values.approveStatus &&
    [
      EApproveStatus.APPROVED,
      EApproveStatus.PAUSED,
      EApproveStatus.REJECTED,
      EApproveStatus.DISABLED,
    ].includes(values.approveStatus)
  );
};

export const ViewStatisticsButton = React.memo<{className?: string; template?: TMessageMatcher}>(
  ({className, template}) => {
    const {t} = useTranslation();
    const methods = useFormContext<TFormData>();
    const values = methods?.watch() ?? template;

    const path = React.useMemo(() => {
      if (!values?.id) {
        return '';
      }

      const backTo = generatePath(getRoute(values.channelType, VIEW_POSTFIX), {
        id: String(values.id),
      });

      return `${generatePath(PATHS.ANALYTICS_MESSAGE_MATCHER, {id: String(values.id)})}?${new URLSearchParams({backTo})}`;
    }, [values]);

    if (!checkTemplateHasStatistics(values)) {
      return null;
    }

    return (
      <Button as={Link} to={path} className={className}>
        {t('MessageMatchers:toStatistics')}
      </Button>
    );
  },
);
